import { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { MDSButton, MDSInput, MDSPopover, MDSTypography } from '@marqvision/mds-v2';
import { getValidUrl } from '../../../utils';

const Styled = {
  LinkPopup: styled.div`
    display: grid;
    gap: 16px;
  `,
  Action: styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    gap: 16px;
  `,
};

type Props = {
  open: Element | null;
  label?: string;
  onSubmit: (value: { label: string; url: string }) => void;
  onClose: () => void;
};

export const AddLinkPopup = (props: Props) => {
  const { open, onSubmit, onClose } = props;

  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');

  const ref = useRef<HTMLDivElement | null>(null);

  const handleSubmit = () => {
    onSubmit({
      label,
      url: getValidUrl(url),
    });
    ref.current?.click();
  };

  const handleClose = () => {
    ref.current?.click();
    onClose();
  };

  useEffect(() => {
    setLabel('');
    setUrl('');
  }, [open]);

  useEffect(() => {
    setLabel(props.label || '');
  }, [props.label]);

  useEffect(() => {
    if (open && ref.current) {
      ref.current.click();
    }
  }, [open]);

  return (
    <MDSPopover anchor={<div ref={ref} />} onClose={handleClose} width="400px">
      <Styled.LinkPopup>
        <MDSTypography variant="title" size="m" weight="semibold">
          Insert link
        </MDSTypography>
        <MDSInput fullWidth label="Text to display" value={label} placeholder="Enter text" onChange={setLabel} />
        <MDSInput fullWidth label="Link to" value={url} size="medium" placeholder="Enter URL" onChange={setUrl} />
        <Styled.Action>
          {/* MDSPlainButton 으로 변경 */}
          <MDSButton variant="border" color="bluegray" size="medium" onClick={handleClose}>
            Cancel
          </MDSButton>
          <MDSButton isDisabled={!label || !url} variant="fill" color="blue" size="medium" onClick={handleSubmit}>
            Insert
          </MDSButton>
        </Styled.Action>
      </Styled.LinkPopup>
    </MDSPopover>
  );
};
